import axios from 'axios';

import { routesAuth } from '~/configs/routes';
import { STORAGE_KEY } from '~/constants';
import { getCurrentLanguage } from '~/helpers/utils';
import config from './serverMicro';

const axiosMicro = axios.create({
  baseURL: config.API_URL,
  timeout: config.DEFAULT_REQUEST_TIMEOUT,
});

// Request interceptor for API calls
axiosMicro.interceptors.request.use(
  async (config) => {
    const access_token = localStorage.getItem(STORAGE_KEY.ACCESS_TOKEN);
    config.headers = {
      Accept: 'application/json',
      Authorization: access_token,
      Locale: getCurrentLanguage(),
    };

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

axiosMicro.interceptors.response.use(
  (response) => response,
  async (error) => {
    try {
      const originalRequest = error.config;
      if (error?.response?.status === 403 && !originalRequest['_retry']) {
        originalRequest['_retry'] = true;
        const refresh_token = localStorage.getItem(STORAGE_KEY.REFRESH_TOKEN);
        axios.defaults.headers.common['Authorization'] = refresh_token;
        return axiosMicro(originalRequest);
      }
      if (error?.response?.status === 401) {
        localStorage.removeItem(STORAGE_KEY.ACCESS_TOKEN);
        window.location.replace(routesAuth.login);
      }

      return Promise.reject(error);
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default axiosMicro;
